import { SxProps, Theme } from "@mui/material";

export const getUploadProgressBannerAppBarSx = (
  theme: Theme,
): SxProps<Theme> => ({
  backgroundColor: theme.palette.success.main,
  height: "44px",
  top: 0,
  textAlign: "center",
  zIndex: 40,
});

export const uploadProgressBannerToolbarSx: SxProps<Theme> = {
  color: "white",
  display: "flex",
  justifyContent: "center",
};
